import React from "react";
import './Testimonials.css';
import starFilled from './images/star.svg';
import starUnfilled from './images/star-unfilled.svg';
import ReactSimplyCarousel from 'react-simply-carousel';

function Testimonials() {
  const [activeSlideIndex, setActiveSlideIndex] = React.useState(0);

  function stars(rating) {
    return (
      <div className='star-container'>
        {[...Array(5).keys()].map(function(r, i){
        return <img src={i < rating? starFilled : starUnfilled} key={i} alt='' />;
    })}
      </div>
    )
  }
  const testimonials = [

    <div key={0} className='testimonial-container'>
      {stars(5)}
      <p className='title'>I learned a lot through Sera's classes</p>
      <p className='sub-title'>Through Sera's classes, I learned how to saved a lot of time and money paying off my credit card debt.</p>
      <p className='name'>Aditi G.</p>
    </div>,

    <div key={1} className='testimonial-container'>
      {stars(4)}
      <p className='title'>It's worth to give it a try</p>
      <p className='sub-title'>I was skeptical when I first signed up for Phong's class, but now I finally feel optimistic about my finances.</p>
      <p className='name'>Robert K.</p>
    </div>,

    <div key={2} className='testimonial-container'>
      {stars(5)}
      <p className='title'>I never thought being debtless was easy</p>
      <p className='sub-title'>Now that I'm out of debt, I'm growing my investments and income and build ing a financial future.</p>
      <p className='name'>Dewayne B.</p>
    </div>,

    <div key={3} className='testimonial-container'>
      {stars(5)}
      <p className='title'>Numbers are not my strength but I learned a lot</p>
      <p className='sub-title'>Making a budget and staying with it seemed overwhelming, but Sera's educational material helped make it much easier.</p>
      <p className='name'>Daniel C.</p>
    </div>,

    <div key={4} className='testimonial-container'>
      {stars(4)}
      <p className='title'>Debt was one of my daily concerns in life</p>
      <p className='sub-title'>When I finally got out of debt, everything changed. The sense of freedom and possibility for my financial future was amazing</p>
      <p className='name'>Melissa J.</p>
    </div>,

    <div key={5} className='testimonial-container'>
      {stars(5)}
      <p className='title'>I was able to pay off my debt faster</p>
      <p className='sub-title'>Sera's courses not only helped me pay off my debt faster, but increased my credit score by over 80 points</p>
      <p className='name'>Minh D</p>
    </div>,

    <div key={6} className='testimonial-container'>
      {stars(5)}
      <p className='title'>Sera's classes helped me a lot!</p>
      <p className='sub-title'>I learned so much through Sera's classes that I now have a financial roadmap and see the light at the end of the tunnel.</p>
      <p className='name'>Louisa M.</p>
    </div>,      
  ];

  return (
    <div className='testimonials'>
      <div className='title'>
      WHAT OUR CUSTOMERS ARE SAYING
      </div>      
      
      <ReactSimplyCarousel
        activeSlideIndex={activeSlideIndex}
        onRequestChange={setActiveSlideIndex}
        itemsToShow={3}
        itemsToScroll={1}
        speed={400}
        easing="linear"
        responsiveProps={[{maxWidth: 1200, itemsToShow: 2, itemsToScroll: 1}, {maxWidth: 480, itemsToShow: 1, itemsToScroll: 1}]}>
          {testimonials}
      </ReactSimplyCarousel>  

      <ul className="testimonial-dot-container">
        {testimonials.map((item, index) => (
          <li key={index}
            className={index === activeSlideIndex ? "active-testimonial-dot testimonial-dot" : "inactive-testimonial-dot testimonial-dot"}
          />
        ))}
      </ul>  
    </div>
  )
}

export default Testimonials;